/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Project_Media_BadgeInputs */



/**
* | output |
* | --- |
* | "Project media" |
*
* @param {Subtitle_Extract_Project_Media_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_project_media_badge = /** @type {((inputs?: Subtitle_Extract_Project_Media_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Project_Media_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Médias du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektmedien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Materiale multimediale del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект медиа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトメディア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना मीडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia do projeto")
	return /** @type {LocalizedString} */ ("Project media")
});